import React from 'react'
import { motion } from "framer-motion"
import service_bg from "../assets/images/services/services-2.jpg"
import { getServiceDate, getServiceData } from '../utlits/fackData/classData';
import CcwForm from '../components/sections/ccwForm' 
import PageTitle from '../components/common/pageTitle'
import { ScrollRestoration } from 'react-router-dom'
import { zoomIn } from '../utlits/zoomIn'

const CcwDetails = () => {
  const ccwDate = getServiceDate(2); // Gets CCW details
  const serviceData = getServiceData(2); // Gets complete service data including dates
  
  return (
    <>
      <PageTitle link={"CCW Details"} pageName={"Concealed Carry Class Details"} />
      <div className="services-details-area pt-100 pb-75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <motion.div className="image"
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(1)}
                viewport={{ once: true, amount: 0 }}
              >
                <img src={service_bg} alt="Enhanced Concealed Carry Class" />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <h1>Concealed Carry Class</h1>
              <h2>$120 | {ccwDate}</h2>
              <br />

             <h3>Woodlawn<br />
              1450 Hwy 98 E Columbia, MS 39429</h3>
              <p>Real-world tactics from an experienced instructor as well as certification to be able to acquire your Enhanced Concealed Carry permit from the state of Mississippi.</p>
              <p>Must have 50 rounds of ammo, pistol, holster, hearing protection, and eye protection.</p>
              <br />
              <p>After you complete the form, you will be taken to our payment page. Your payment is required to reserve your seat immediately.
              If you have any questions or concerns please contact us at j5solutionssp@gmail.com. You can also call or text (601)633-1159.
              We look forward to training with you.</p>
            </div>
          </div>
        </div>
        <div className="services-details-area pt-100 pb-75"> 
          <CcwForm serviceData={serviceData} />
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default CcwDetails